import { useState } from "react";
import { useNavigate, Link, Navigate } from "react-router-dom";
import { loginAccount } from "../api/client";
import { useAuth } from "../context/AuthContext";
import FastSendLogo from "../components/FastSendLogo";
import ContactFooter from "../components/ContactFooter";

const ROLE_HOME = { user: "/dashboard", rider: "/rider/dashboard", admin: "/admin/riders" };

export default function Login() {
  const [role, setRole] = useState("user");
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { account, login } = useAuth();
  const navigate = useNavigate();

  if (account) {
    return <Navigate to={ROLE_HOME[account.role] || "/dashboard"} replace />;
  }

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await loginAccount(role, form);
      login(data.token, role, data[role]);
      navigate(ROLE_HOME[role]);
    } catch (err) {
      setError(err.response?.data?.error || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <div className="brand-header" style={{ marginBottom: "28px" }}>
        <FastSendLogo size="medium" showTagline={true} />
      </div>

      <div className="role-tabs">
        {["user", "rider"].map((r) => (
          <button
            key={r}
            type="button"
            className={role === r ? "role-tab active" : "role-tab"}
            onClick={() => setRole(r)}
          >
            {r === "user" ? "📦 Customer" : "🏍️ Dispatcher"}
          </button>
        ))}
      </div>

      <form onSubmit={handleSubmit}>
        <input name="email" type="email" placeholder="Email address" value={form.email} onChange={handleChange} required />
        <input name="password" type="password" placeholder="Password" value={form.password} onChange={handleChange} required />
        {error && <p className="error">{error}</p>}
        <button type="submit" disabled={loading}>{loading ? "Logging in…" : "Log in"}</button>
      </form>

      <p className="text-link">
        New here? <Link to={`/register/${role}`}>Create an account</Link>
      </p>
      {/* <p className="text-link" style={{ marginTop: "6px" }}>
        <Link to="/admin/login" style={{ color: "var(--text-muted)", fontSize: "13px" }}>⚙️ Admin login</Link>
      </p> */}

      <ContactFooter />
    </div>
  );
}
